export const appRootId = "cpp"

export const appRootTag = "div"

export const appBaseURL = "/"

export const appBuildAssetsDir = "cpp/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"}],"link":[{"rel":"preconnect","href":"https://stc-test.dngroup.com/"},{"rel":"icon","type":"image/x-icon","href":"https://stc-test.dngroup.com/cpp/europower/icons/favicon.ico"},{"rel":"apple-touch-icon","sizes":"57x57","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https://stc-test.dngroup.com/cpp/europower/icons/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"72x72","href":"https://stc-test.dngroup.com/cpp/europower/icons/android-icon-72x72.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://stc-test.dngroup.com/cpp/europower/icons/android-icon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"144x144","href":"https://stc-test.dngroup.com/cpp/europower/icons/android-icon-144x144.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"https://stc-test.dngroup.com/cpp/europower/icons/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://stc-test.dngroup.com/cpp/europower/icons/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://stc-test.dngroup.com/cpp/europower/icons/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://stc-test.dngroup.com/cpp/europower/icons/favicon-96x96.png"},{"rel":"preconnect","href":"https://image-test.dngroup.com/global/nhst/binary/:key"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Erode/Erode-Variable.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Erode/Erode-VariableItalic.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Inter/InterVariable.woff2","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Sueca/suecatx-regular.woff","type":"font/woff","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Sueca/suecatx-bold.woff","type":"font/woff","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https://stc-test.dngroup.com/cpp/fonts/Sueca/suecatx-italic.woff","type":"font/woff","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"nb"},"bodyAttrs":{},"title":"Europower"}

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootAttrs = {"id":"cpp"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"remove","externalRelAttribute":"noopener","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#cpp'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true